// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","vRadiusMiddle":"12px","header":"CatalogShowcaseHeader_header__isowl","name":"CatalogShowcaseHeader_name__2ZnSO","actions":"CatalogShowcaseHeader_actions__3cBrL"};